import $ from 'jquery';
import '../vendor/slick-carousel/slick.fix';
import BackgroundImage from './BackgroundImage';

const defaults = {
  speed: 500,
  fade: true,
  slide: '.views-row',
  autoplay: true,
  autoplaySpeed: 2000,
  dots: true,
  arrows: false,
  slidesToShow: 1,
  slidesToScroll: 1,
  responsive: [{
    breakpoint: 1025,
    settings: {
      fade: false,
    },
  }],
};

/**
 * Slider Constructor
 */
function StatsSlider(element, options) {
  this.element = element;
  this.$element = $(element);
  this.settings = { ...defaults, ...options };
  this.addBackgrounds = this.addBackgrounds.bind(this);
  this.slider = this.build();
  this.ready();
}

StatsSlider.prototype = {
  build() {
    const $slider = this.$element.find('.view-content');
    $slider.on('init breakpoint', this.addBackgrounds);
    return $slider.slick(this.settings);
  },
  addBackgrounds() {
    $(this.settings.slide, this.element).each((i, element) => {
      element.backgroundImage = new BackgroundImage(element, {
        sourceSelector: 'img',
      });
    });
  },
  ready() {
    this.$element.addClass('ready');
  },
};

export default StatsSlider;



// WEBPACK FOOTER //
// ./HeroSlider.js